import { render, staticRenderFns } from "./TaskCreateMenu.vue?vue&type=template&id=fc791cf4&scoped=true"
import script from "./TaskCreateMenu.vue?vue&type=script&lang=ts"
export * from "./TaskCreateMenu.vue?vue&type=script&lang=ts"
import style0 from "./TaskCreateMenu.vue?vue&type=style&index=0&id=fc791cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc791cf4",
  null
  
)

export default component.exports